import { Checkbox, Col, Form, Row, Select } from "antd";
import { MyText } from "../../../common/MyText/MyText";
import { MyButton } from "../../../common/MyButton/MyButton";
import React, { useCallback, useEffect, useState } from "react";
import { RootState } from "../../../../store";
import { useDispatch, useSelector } from "react-redux";
import { selectStore } from "../../../../store/selector";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { printJournal } from "../../../../store/pages/printJournal/actions";
import { JOURNAL_TYPES } from "../../../../constants";

const courseArray = [1, 2]

export const Print = ({ filterForm, type }: any) => {
  const { t } = useTranslation("common")
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [checkboxParams, setCheckboxParams] = useState<any[]>([]);
  const [checkboxSubject, setCheckboxSubject] = useState<any[]>([]);

  const [currentCourse, setCurrentCourse] = useState(1)

  const {
    printJournal: {
      printJournal: printJournalState,
      printJournalParams: printJournalParamsState,
      printJournalSubjectList: printJournalSubjectListState,
    }
  }: RootState = useSelector(selectStore)

  const checkAllParams = checkboxParams.length === printJournalParamsState?.data?.length;
  const indeterminateParams = checkboxParams.length > 0 && checkboxParams.length < printJournalParamsState?.data?.length;

  const checkAllSubject = checkboxSubject.length === printJournalSubjectListState?.data?.length;
  const indeterminateSubject = checkboxSubject.length > 0 && checkboxSubject.length < printJournalSubjectListState?.data?.length;

  useEffect(() => {
    if (printJournalSubjectListState.data) {
      setCheckboxSubject(printJournalSubjectListState.data?.map((item: any) => item?.id))
    }
  }, [printJournalSubjectListState.data])

  const handleClickPrintJournal = () => {
    let params = printJournalParamsState?.data.reduce((result: any, item: any) => {
      result[item.name] = checkboxParams?.some(inner => inner === item.name);
      return result;
    }, {})

    let body = {
      course: filterForm.getFieldsValue().course,
      group: filterForm.getFieldsValue().group,
      academic_year: filterForm.getFieldsValue().year,
      teacher_id: filterForm.getFieldsValue().teacher_id,
      ...(currentCourse ? { semester: currentCourse } : {}),
      'subject_ids[]': checkboxSubject,
      ...params
    }

    let url = {
      [JOURNAL_TYPES.THEORETICAL]: 'theoretic',
      [JOURNAL_TYPES.INDUSTRIAL]: 'industrial',
      [JOURNAL_TYPES.TEACHERS_PRACTICE]: 'industrial-accounting',
      [JOURNAL_TYPES.INDIVIDUAL]: 'individual'
    }
    dispatch(printJournal({
      body: body, url: url[type]
    }))
    return;
  }

  const handleParamsChange = (list: any) => {
    setCheckboxParams(list)
  }

  const handleSubjectChange = (list: any) => {
    setCheckboxSubject(list)
  }

  const paramsCheckAllChange = (e: any) => {
    let array: any = printJournalParamsState?.data?.map((item: any) => item?.name)
    setCheckboxParams(e.target.checked ? array : [])
  }

  const subjectCheckAllChange = (e: any) => {
    let array: any = printJournalSubjectListState?.data?.map((item: any) => item?.id)
    setCheckboxSubject(e.target.checked ? array : [])
  }

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Row align='middle' justify='space-between'>
          <Col>
            <MyText size={24} weight={500}>
              Печать журнала
            </MyText>
          </Col>

          {
            printJournalParamsState?.data?.length > 0 &&
            <Col>
              <Select options={[{
                key: null,
                label: '-',
                value: null,
              }, ...courseArray.map(item => ({
                key: item,
                label: `${item} семестр`,
                value: item
              }))]} style={{ width: 100 }} placeholder='Укажите период' value={currentCourse} onSelect={(value, option) => setCurrentCourse(value)} />
            </Col>
          }

        </Row>
      </Col>

      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Row gutter={[16, 16]}>
              {
                printJournalParamsState?.data?.length > 0 &&
                <Col span={24}>
                  <Checkbox onChange={paramsCheckAllChange} checked={checkAllParams}
                    indeterminate={indeterminateParams}>
                    Все
                  </Checkbox>
                </Col>
              }
              <Col span={24}>
                <Checkbox.Group onChange={handleParamsChange} value={checkboxParams}>
                  <Row gutter={[16, 16]}>
                    {printJournalParamsState?.data?.map((item: any) => (
                      <Col key={item?.name} span={24}>
                        <Checkbox value={item?.name}>
                          {item?.caption}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row gutter={[16, 16]}>
              {
                printJournalSubjectListState?.data?.length > 0 &&
                <Col span={24}>
                  <Checkbox onChange={subjectCheckAllChange} checked={checkAllSubject}
                    indeterminate={indeterminateSubject}>
                    Все
                  </Checkbox>
                </Col>
              }

              <Col span={24}>
                <Checkbox.Group onChange={handleSubjectChange} value={checkboxSubject}>
                  <Row gutter={[16, 16]}>
                    {printJournalSubjectListState?.data?.map((item: any) => (
                      <Col key={item?.id} span={24}>
                        <Checkbox value={item?.id}>
                          {item?.subgroup?.caption} {item?.subgroup?.caption ? '-' : ''} {item?.caption} ( {item?.group ? (item?.group) : item?.teachers?.map((teacher: any) => teacher?.full_name)?.join(', ')})
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>

      <Col span={24}>
        <Row justify='center'>
          <Col>
            <MyButton title='Распечатать' type='primary' ghost onClick={handleClickPrintJournal}
              loading={printJournalState.loading} />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
